import React from "react";

// Tree and Table are two views of ONE dataset, not two sections of a page.
// Both at once is too much, so it is a toggle — and selection is shared across
// it, which is the payoff of the single polymorphic `selected` value.
//
// Deliberately NOT tied to a breakpoint: silently overriding someone's choice
// when they rotate a phone is worse than a small default.
const VIEWS = [
  ["tree", "Tree"],
  ["table", "Table"]
];

// NOT role="tab". It said tablist/tab and then did not implement the keyboard
// contract that goes with them: arrow keys did nothing, and there was no roving
// tabIndex, so it announced "tab, 1 of 2" and then ignored the keys a reader
// would press next. Announcing a pattern and not honouring it is worse than not
// announcing it.
//
// Tree and Table are a display mode rather than two panels of content, so two
// pressed buttons in a group is both simpler and more accurate — and
// aria-pressed carries no keyboard contract to get wrong.
export default function ViewToggle({ view, onChange }) {
  return (
    <div className="viewtoggle" role="group" aria-label="View">
      {VIEWS.map(([id, label]) => (
        <button
          key={id}
          type="button"
          aria-pressed={view === id}
          className={view === id ? "viewtoggle__tab viewtoggle__tab--on" : "viewtoggle__tab"}
          onClick={() => onChange(id)}
          data-testid={`view-${id}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
